import { Check } from "lucide-react";

const STEPS = ["Upload", "Daten", "Ziele", "Analyse", "Angebot"];

export const Stepper = ({ current }) => {
    return (
        <div data-testid="analyse-stepper" className="mx-auto max-w-2xl">
            <div className="flex items-center">
                {STEPS.map((label, i) => {
                    const done = i < current;
                    const active = i === current;
                    return (
                        <div key={label} className="flex flex-1 items-center last:flex-none">
                            <div className="flex flex-col items-center">
                                <div
                                    className={`flex h-9 w-9 items-center justify-center rounded-full border text-sm font-semibold transition-colors ${
                                        done
                                            ? "border-primary bg-primary text-white"
                                            : active
                                            ? "border-primary bg-primary/15 text-primary"
                                            : "border-border bg-surface text-[#52525B]"
                                    }`}
                                >
                                    {done ? <Check className="h-4 w-4" /> : i + 1}
                                </div>
                                <span
                                    className={`mt-2 hidden text-xs sm:block ${
                                        active ? "text-white" : "text-[#52525B]"
                                    }`}
                                >
                                    {label}
                                </span>
                            </div>
                            {i < STEPS.length - 1 && (
                                <div
                                    className={`mx-2 h-px flex-1 ${done ? "bg-primary" : "bg-border"}`}
                                />
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default Stepper;
